import { isDebug, isMobileApp } from "@/constants";

export const getWorkerName = (nodeEnv: string, env: string) =>
  JSON.stringify({
    isDebug,
    isMobileApp,
    nodeEnv,
    env,
  });
